import * as staticData from './service';

export const LOAD_STATIC_DATA_SUCCESS = 'LOAD_STATIC_DATA_SUCCESS';
export const loadStaticData = (callback) => {
  return async (dispatch, getState) => {
    const state = getState();
    const staticDataFromStore = state.staticData;
    if (staticDataFromStore.data && Object.keys(staticDataFromStore.data).length>0) {
      callback(staticDataFromStore.data);
    } else {
      const result = await staticData.getStaticData();
      dispatch({
        type: LOAD_STATIC_DATA_SUCCESS,
        payload: result?.data
      });
      callback(result?.data);
    }
  }
};
  